<div class="formal-preview-shell">
  <div class="card border rounded-lg shadow-sm bg-white report-step-card formal-preview-card">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center gap-2 mb-3">
        <div>
          <p class="text-uppercase text-muted text-xxs mb-1">Preview</p>
          <h5 class="text-x fw-bold mb-0">Live PDF preview</h5>
        </div>
        <div class="d-flex align-items-center gap-2">
          <span class="badge rounded-small bg-light text-dark text-xxs px-3 py-2">
            {{ visible_section_count }} sections
          </span>
          <span class="badge rounded-small bg-light text-dark text-xxs px-3 py-2">
            {{ preview_status_label }}
          </span>
        </div>
      </div>

      <div class="formal-preview-paper rounded-lg">
        <div
          v-if="preview_loading && !preview_html"
          class="d-flex align-items-center justify-content-center text-muted text-xxs formal-preview-frame"
        >
          Rendering live preview...
        </div>

        <div
          v-else-if="preview_error"
          class="alert alert-light border rounded-small shadow-sm text-xxs mb-0"
          role="alert"
        >
          {{ preview_error }}
        </div>

        <iframe
          v-else
          :key="preview_frame_key"
          :srcdoc="preview_html"
          class="formal-preview-frame bg-white border-0 rounded"
          loading="lazy"
          referrerpolicy="no-referrer"
          sandbox="allow-same-origin"
          title="Live PDF preview"
        ></iframe>
      </div>
    </div>
  </div>
</div>
